function initialiseCustomProductCarousel(carousel) {
  if (!(carousel instanceof HTMLElement) || carousel.dataset.customCarouselReady === 'true') return;

  carousel.dataset.customCarouselReady = 'true';

  let pointerId;
  let startX = 0;
  let startScrollLeft = 0;
  let hasDragged = false;
  let suppressClick = false;

  carousel.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || carousel.scrollWidth <= carousel.clientWidth) return;

    pointerId = event.pointerId;
    startX = event.clientX;
    startScrollLeft = carousel.scrollLeft;
    hasDragged = false;
    carousel.classList.add('is-dragging');
    carousel.setPointerCapture(pointerId);
  });

  carousel.addEventListener('pointermove', (event) => {
    if (event.pointerId !== pointerId) return;

    const distance = event.clientX - startX;
    if (Math.abs(distance) > 5) hasDragged = true;
    if (!hasDragged) return;

    event.preventDefault();
    carousel.scrollLeft = startScrollLeft - distance;
  });

  const finishDrag = (event) => {
    if (event.pointerId !== pointerId) return;

    suppressClick = hasDragged;
    carousel.classList.remove('is-dragging');

    if (carousel.hasPointerCapture(pointerId)) carousel.releasePointerCapture(pointerId);
    pointerId = undefined;

    window.setTimeout(() => {
      suppressClick = false;
    }, 0);
  };

  carousel.addEventListener('pointerup', finishDrag);
  carousel.addEventListener('pointercancel', finishDrag);

  carousel.addEventListener(
    'click',
    (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );
}

function initialiseCustomProductCarousels(root = document) {
  if (root instanceof Element && root.matches('[data-custom-product-carousel]')) {
    initialiseCustomProductCarousel(root);
  }
  root.querySelectorAll('[data-custom-product-carousel]').forEach(initialiseCustomProductCarousel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initialiseCustomProductCarousels(), { once: true });
} else {
  initialiseCustomProductCarousels();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initialiseCustomProductCarousels(event.target);
});
